import React, {useEffect, useState} from 'react'
import styled from "styled-components";
import WrapComponent from "./piece/wrapCompoent";
import {numberFormat} from '../../../../libs/util'
import {itemAPI2} from "../../../../libs/api2";
import LayerCaution from "./layerCaution/layerCaution";
import LayerContents from "./layerContents/layerContents";
import {Button} from "../elementPiece/button";

const PcInstallComponent=({itemId, action, setServiceAddFn, setPcInstallFlag})=>{
    const [serviceInfo, setServiceInfo]=useState({})
    const [isLoading, setIsLoading]=useState(false)
    const [checkedCaution, setCheckedCaution]=useState(false) //주의사항
    const [checkedCautionAlert, setCheckedCautionAlert]=useState(false) //주의사항 경고
    const [checkedCautionContent, setCheckedCautionContent]=useState(false) //주의사항 내용

    useEffect(() => {
        serviceInfoFn()
    }, []);

    const serviceInfoFn=()=>{
        itemAPI2.getServiceInfo(itemId).then((res)=>{
            if(res){
                const service = res.data.data.item
                setServiceInfo({name:service.itemName, price:service.price, count:1})
            }
            setTimeout(()=>{
                setIsLoading(true)
            },150)
        }).catch(err=> {
            const errData = err.response.data
            errData.errors.itemId.map(v => {
                const data = v.split('|')
                setPcInstallFlag(data[1])
            })
            action()
            return false
        })
    }

    const setEstimateCount = (type) => {
        setServiceInfo(prevState => {
            let count = prevState.count;
            if (type === 'plus') { count += 1; }
            if (type === 'minus') { count -= 1; }
            if (count === 0) { count = 1; }
            return {...prevState, count: count};
        });
    }

    const addEstimateItem = () => {
        if (checkedCaution === false) {
            setCheckedCautionAlert(true)
            setCheckedCautionContent(true)
            return false
        }
        setServiceAddFn(itemId, serviceInfo.count, action)
    }

    /**
     * 주의사항 확인
     */
    const onCheckCautionFn = (e) => {
        const {checked} = e.target
        setCheckedCaution(checked)
        setCheckedCautionAlert(false)
        setCheckedCautionContent(false)
    }

    /**
     * 주의사항 내용 보기
     * */
    const onClickCaution = () => {
        setCheckedCautionContent(prev => !prev)
    }

    return(
        <>
            <WrapComponent>
                {!isLoading
                    ? (
                        <Loading cdnimg={process.env.REACT_APP_CDN_IMG}/>
                    ) : (
                        <LayerPop>
                            <div className="layer-pop_osset_head">
                                <h4 className="tit-h4">
                                    <span>직접 PC 설치</span>가 어려우신가요?
                                </h4>
                            </div>

                            <div className='pc-install-body'>
                                <div className="pc-install-body-box">
                                    <div className="pc-install-body-top">
                                        <span className="title">{serviceInfo.name}</span>

                                        <div className="count">
                                            <Button
                                                type={`countBtn`}
                                                className="btn_cnt_minus"
                                                onClick={() => setEstimateCount('minus')}
                                            >
                                                <i className="icon-remove"/>
                                                <span className="ir">감소</span>
                                            </Button>
                                            <Button
                                                type={`countBtn`}
                                                className="btn_cnt_plus"
                                                onClick={() => setEstimateCount('plus')}
                                            >
                                                <i className="icon-add"/>
                                                <span className="ir">증가</span>
                                            </Button>
                                            <input
                                                type="text"
                                                className="inum"
                                                title="개수"
                                                value={serviceInfo.count}
                                                onChange={() => {}}
                                            />
                                        </div>

                                        <strong className="price">
                                            {numberFormat(serviceInfo.price * serviceInfo.count)}
                                            <span>원</span>
                                        </strong>
                                    </div>

                                    <div className="button-group">
                                        <Button
                                            type={'serviceBtn'}
                                            className={`btn_flat`}
                                            onClick={() => addEstimateItem()}
                                        >
                                            예! 서비스 신청하겠습니다.
                                        </Button>
                                        <Button
                                            type={'serviceBtn'}
                                            className={`btn_border`}
                                            onClick={action}
                                        >
                                            아니오! 직접 해결하겠습니다.
                                        </Button>
                                    </div>
                                </div>

                                {/*조립서비스 종류에 따라 달라지는 레이어 팝업의 컨텐츠*/}
                                {/*icon + 설명 영역*/}
                                <LayerContents itemNumber={`${itemId}`}/>

                                <Caution className="pc-install-caution-box">
                                    <div className="pc-install-caution-box-top">
                                        <span className={!checkedCautionAlert ? 'icheck' : 'icheck required'}>
                                            <input
                                                type="checkbox"
                                                id="id-checkPcInstallCautions"
                                                checked={checkedCaution}
                                                onClick={e => onCheckCautionFn(e)}
                                                onChange={() => {}}
                                            />
                                            <label htmlFor="id-checkPcInstallCautions">
                                                {!checkedCautionAlert
                                                    ? (
                                                        <span style={{width:'135px'}}>주의사항을 확인했습니다.</span>
                                                    ) : (
                                                        <span style={{color:'#f34522',width:'135px'}}>주의사항을 확인해 주세요.</span>
                                                    )
                                                }
                                            </label>
                                        </span>

                                        <Button
                                            type='cautionBtn'
                                            onClick={onClickCaution}
                                        >
                                            {checkedCautionContent
                                                ? (
                                                    <>닫기 <i className="icon-angle-up"/></>
                                                ) : (
                                                    <>내용보기 <i className="icon-angle-down"/></>
                                                )
                                            }
                                        </Button>
                                    </div>

                                    {checkedCautionContent && (
                                        <CautionUl>
                                            {/*조립서비스 종류에 따라 달라지는 레이어 팝업의 주의사항 텍스트*/}
                                            <LayerCaution itemNumber={`${itemId}`}/>
                                        </CautionUl>
                                    )}
                                </Caution>
                            </div>

                            <Button
                                type={`close`}
                                className={`icon-close btn-layer-pop_clse`}
                                onClick={action}
                            >
                                <span className="ir">닫기</span>
                            </Button>
                        </LayerPop>
                    )
                }
            </WrapComponent>
        </>
    )
}
export default PcInstallComponent

const Loading = styled.div`
    display: flex;
    width: 950px;
    height: 138px;
    align-items: center;
    justify-content: center;
    background: ${(props) =>
    `transparent url(${props.cdnimg}/img_static/img_pres/_v5/happy_loading_5.gif) no-repeat center`};
    background-size: 60px 69px;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`

const LayerPop = styled.div`
    font-family: 'Noto Sans KR', "나눔고딕", 'Nanum Gothic', "맑은고딕", 'Malgun Gothic', ‘Apple SD Gothic Neo’, "돋움", dotum, "굴림", gulim, sans-serif;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width:758px;
    box-sizing: border-box !important;
    background: #fff;
    padding:50px 30px 20px;
    border:2px solid #444;

    .tit-h4{
        font-size: 32px;
        text-align: center;
        letter-spacing: -3px;
        span{ color: #f34522; }
    }

    .pc-install-body{
        margin-top:30px;
    }
    .pc-install-body-box{
        padding: 30px;
        border: 2px solid #418ded;
        background: #f4f4f4;
        .pc-install-body-top{
            &:after{
                display: block;
                clear: both;
                height: 0;
                font-size: 0;
                line-height: 0;
                content: '';
            }
            margin-bottom: 7px;
            .title{
                float: left;
                font-size: 20px;
                font-weight: bold;
                line-height: 30px;
            }
            .count{
                position: relative;
                float: left;
                margin-left: 10px;
                padding: 0 28px;
                border: 1px solid #666;
                border-top: 0;
                border-bottom: 0;
                height: 30px;
                .inum{
                    width: 32px;
                    height: 30px;
                    border-width: 1px;
                    border-style: solid;
                    border-color: #666;
                    font-weight: bold;
                    text-align: center;
                    letter-spacing: 0;
                    box-sizing: border-box;
                }
            }
            .price{
                float: left;
                height: 30px;
                margin-left: 10px;
                font-size: 22px;
                color: #f34522;
                letter-spacing: 0;
                line-height: 30px;
            }
        }

        .button-group{
            margin-top: 32px;
            text-align: center;
        }
    }
`

const Caution = styled.div`
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e8e7ea;
    .icheck{
        margin-right: 10px;
        font-size: 0;
    }
    label{
        display: inline-block;
        span{
            display: inline-block;
            font-size: 12px;
            font-weight: bold;
            vertical-align: middle;
        }
    }
`

const CautionUl = styled.ul`
    margin-top: 20px;
    li{
        padding-left: 12px;
        color: #666;
        line-height: 20px;
        word-break: keep-all;
        word-wrap: break-word;
    }
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/service/serviceAsseblyLayer/pcInstallComponent.js